var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkout-items" }, [
    _c(
      "div",
      { staticClass: "items" },
      _vm._l(_vm._items, function (item) {
        return _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "item-top" }, [
            _c("div", { staticClass: "left-col" }, [
              _c("div", { staticClass: "item-desc" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("formatUTCDate")(_vm.booking.date, "ddd. MM/DD/YYYY")
                  )
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-name" }, [
                _vm._v(_vm._s(item.inventory.name)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-desc" }, [
                _vm._v(_vm._s(_vm.booking.name)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "right-col" }, [
              _c("div", { staticClass: "item-quantity" }, [
                _vm.showItemQuantity(item)
                  ? _c(
                      "select",
                      {
                        staticClass: "form-control form-control-xs",
                        domProps: { value: item.quantity },
                        on: {
                          change: function ($event) {
                            _vm.updateBookingItems(item, $event.target.value)
                          },
                        },
                      },
                      _vm._l(_vm.getItemQuantityMax(item), function (n) {
                        return _c("option", { domProps: { value: n } }, [
                          _vm._v(_vm._s(n) + "x"),
                        ])
                      })
                    )
                  : _c("div", { staticClass: "quantity-text" }, [
                      _vm._v(_vm._s(item.quantity) + "x"),
                    ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-price" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("venueCurrency")(
                      item.totalWithoutDiscounts,
                      _vm.venue.currencyCode,
                      _vm.venue.languageCode
                    )
                  )
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          item.description
            ? _c(
                "div",
                { staticClass: "item-description" },
                [
                  item.description
                    ? _c("read-more", {
                        staticClass: "inventory-description",
                        attrs: { "max-chars": 200, text: item.description },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ])
      })
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/CheckoutItems/template.html?vue&type=template&id=1371381d&
// module id = 1037
// module chunks = 0